import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeMillisToMinutes'
})
export class TimeMillisToMinutesPipe implements PipeTransform {

  transform(value) {
    const minutes = value / 1000 / 60;
    return minutes.toFixed(2);
  }

}
